import React from "react";
import { connect } from "react-redux";
import { styled } from "@acko-tech/building-blocks.ui.common";
import DOMPurify from "isomorphic-dompurify";

import { getWidgetSpecificProps } from "@utils/index";
import { CommonProps } from "@utils/interface";
import { Text } from "@acko-tech/building-blocks.ui.typography";

interface ITextComponent extends CommonProps {
  text: string;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return getWidgetSpecificProps(
    state.configuration?.normalisedConfig,
    ownProps.id
  );
};

const TextComponent = (props: ITextComponent) => {
  const { text, styles, is_visible, id } = props || {};

  const StyledText = styled(Text)`
    ${(props) => props.styles}
  `;

  return (id && is_visible) || !id ? (
    <StyledText
      styles={styles}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(text)
      }}
    />
  ) : null;
};

export default connect(mapStateToProps)(TextComponent);
